// Query keys for React Query
import type { DownloadHistoryFilters } from "@/api/api";

export const queryKeys = {
  // Assets
  assets: ["assets"] as const,
  assetDownloadUrl: (path: string) => ["assets", "download-url", path] as const,
  downloadHistory: (filters: DownloadHistoryFilters) => ["downloads", "history", filters] as const,

  // Licenses
  licenses: (orgId?: string, includeInactive?: boolean) => ["licenses", { orgId, includeInactive }] as const,
  licenseStatistics: (orgId?: string) => ["licenses", "statistics", orgId] as const,

  // JFrog Tokens
  jfrogTokens: (orgId?: string, includeRevoked?: boolean) => ["jfrogTokens", orgId, { includeRevoked }] as const,

  jfrogServiceAccount: (orgId: string) => ["jfrogServiceAccount", orgId] as const,

  // Organizations
  orgs: ["orgs"] as const,
  licenseOrgs: ["orgs", "licenses"] as const,
  orgUsers: (orgId: string) => ["orgs", orgId, "users"] as const,
  orgUsersForLicense: (orgId: string) => ["orgs", orgId, "users", "license"] as const,
  sharedFiles: (orgId: string, params?: object) =>
    params ? (["orgs", orgId, "files", params] as const) : (["orgs", orgId, "files"] as const),
  sharedFileActivity: (orgId: string, params?: object) =>
    params ? (["orgs", orgId, "file-activity", params] as const) : (["orgs", orgId, "file-activity"] as const),

  // File share
  fileShareConfig: ["fileShare", "config"] as const,

  // Roles
  orgRoles: (orgId: string) => ["orgs", orgId, "roles"] as const,

  // Users
  currentUser: ["user", "current"] as const,
  currentOrgUsers: (orgId?: string) => ["users", "org", orgId] as const,
  allUsers: ["users", "all"] as const,
  myOrgs: ["organizations", "my"] as const,
} as const;
